import {AuthContext} from '@/context/Auth/AuthContext'
import { UserRoleContext } from '@/context/UserRole/UserRoleContextInstance'
import {UserRoleProvider} from '@/context/UserRole/UserRoleProvider'
import {Template} from '@/pages/Template'
import {useContext, useEffect} from 'react'
import {Outlet, useNavigate} from 'react-router-dom'
import {useAuth} from '@/hooks/useAuth'

export const ProtectedRoutes = () => {
  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  )
}

const ProtectedRoutesContent = () => {
  const {isAuthenticated} = useAuth()
  const {isAuthorized} = useContext(UserRoleContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      const preLoginPath = localStorage.getItem('preLoginPath')
      if (preLoginPath) {
        localStorage.removeItem('preLoginPath')
        navigate(preLoginPath)
      }
    }
  }, [isAuthenticated, navigate])

  const canRenderRoute = isAuthenticated && isAuthorized

  return canRenderRoute ? <Outlet /> : null
}
